"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ContentEditable_1 = require("./ContentEditable");
const colors_1 = require("../styles/colors");
class PlaceholderComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hidePlaceholder: false,
        };
        this.handlePlaceholderChange = this.handlePlaceholderChange.bind(this);
    }
    handlePlaceholderChange(val) {
        this.setState({
            hidePlaceholder: val.length !== 0,
        });
    }
    render() {
        const { html, placeholderText, style, onChange, onInputChange, id, contentEditable, onBlurChange, handleBlurChange, inputType, } = this.props;
        const { hidePlaceholder } = this.state;
        const contentEditableStyle = Object.assign({}, style, { position: 'absolute', top: 0, left: 0, zIndex: 3 });
        return (React.createElement("div", { style: {
                position: 'relative',
                height: this.props.style.lineHeight,
            } },
            !hidePlaceholder && (React.createElement("div", { style: Object.assign({ position: 'absolute', top: 0, left: 0 }, this.props.style, { color: colors_1.silver, zIndex: 2 }) }, placeholderText)),
            contentEditable && (React.createElement(ContentEditable_1.default, { html: html, onChange: onChange, onInputChange: onInputChange, id: id, onBlurChange: onBlurChange, style: contentEditableStyle, handlePlaceholderChange: this.handlePlaceholderChange, placeholder: true, handleBlurChange: handleBlurChange, inputType: inputType }))));
    }
}
PlaceholderComponent.defaultProps = {
    onBlurChange: true,
    inputType: 'ANY',
};
exports.default = PlaceholderComponent;
